var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAutoMessage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66699 14.0255V2.87176C1.66699 2.535 1.78366 2.24996 2.01699 2.01663C2.25033 1.78329 2.53537 1.66663 2.87213 1.66663H13.1285C13.4652 1.66663 13.7503 1.78329 13.9836 2.01663C14.217 2.24996 14.3336 2.535 14.3336 2.87176V6.53839H13.3336V2.87176C13.3336 2.82047 13.3123 2.77345 13.2695 2.73071C13.2268 2.68798 13.1798 2.66661 13.1285 2.66661H2.87213C2.82084 2.66661 2.77382 2.68798 2.73108 2.73071C2.68834 2.77345 2.66698 2.82047 2.66698 2.87176V11.5897L3.60033 10.6666H9.97466V11.6666H4.02596L1.66699 14.0255ZM2.66698 10.6666V11.1282V2.66661V10.6666ZM12.6413 14.5896V11.6666H11.5644V8.12818H14.1605L13.2195 10.5384H14.5387L12.6413 14.5896Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutoMessage);
export default __webpack_public_path__ + "static/media/AutoMessage.380de81fc691146cc4c89005648a28a0.svg";
export { ForwardRef as ReactComponent };